import { PERMISSIONS } from '@admin/config/permissions';
import { DISPATCHER_REQUEST, DISPATCH_MANAGEMENT } from '@admin/libraries/access_control_catalog.generated';

export const canReadDispatcherRequest = () => PERMISSIONS.has(DISPATCHER_REQUEST.keys.read);

export const canCreateDispatcherRequest = () => PERMISSIONS.has(DISPATCHER_REQUEST.keys.create);

/** Upsert + status polling require both create and read on `dispatcherRequest`. */
export const canUseDispatcherRequestFlow = () => canCreateDispatcherRequest() && canReadDispatcherRequest();

/** Dispatcher board Manage button and edit workflow. */
export const canManageDispatchBoard = () => PERMISSIONS.has(DISPATCH_MANAGEMENT.keys.update);
